import { Injectable, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class WatchVideoService {
  constructor(private http: HttpClient) {}
  videoLoading = signal<boolean>(true);
  srcVideo(payload: { url: string; time: number }): void {
    // this.watchVideoStore.update({ src: payload });
  }

  pauseVideo(): void {
    // this.watchVideoStore.update({ isPause: true });
  }

  unpauseVideo(): void {
    // this.watchVideoStore.update({ isPause: false });
  }

  sessionVideoToken(): Observable<{ storage_token: string }> {
    return this.http.get<{ storage_token: string }>(`/sessions/storage_token`);
  }

  /**
   * Enrolled HLS access — requires login + a non-expired enrolment. Issues the
   * signed HLS cookie (HttpOnly); nginx secure_link verifies it on every /hls
   * segment, so the playback URL stays clean (no token query). Same scheme as
   * eazycal's watch player — edvance has converged onto it. withCredentials so
   * the Set-Cookie is stored.
   */
  requestHlsAccess(chapterId: number): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(
      `/hls_access`,
      { chapter_id: chapterId },
      { withCredentials: true },
    );
  }

  /**
   * Public free-trial ("ทดลองเรียน") access — no login. The API only issues the
   * cookie when the chapter is flagged is_preview; otherwise identical to
   * requestHlsAccess above.
   */
  requestPreviewAccess(chapterId: number): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(
      `/hls_access/preview`,
      { chapter_id: chapterId },
      { withCredentials: true },
    );
  }
}
